<template>
  <div class="light-apply">
    <inputField
      id="applyName"
      label="姓名"
      placeholder="請輸入"
      inputType="name"
      maxLength="50"
      class="light-name"
      :value="displayInfo.applyName"
      @onInput="onInput($event)"
      :errorText="errorText.applyName"
    />
    <inputField
      id="applyPhone"
      label="手機號碼/聯絡電話"
      placeholder="請輸入"
      inputType="phone"
      maxLength="11"
      class="light-phone"
      :value="displayInfo.applyPhone"
      @onInput="onInput($event)"
      :errorText="errorText.applyPhone"
    />
    <div class="light-footer-steps">
      <div
        class="temple-button-text light-footer-previous"
        @click="previousClick"
      >
        上一步
      </div>
      <div class="temple-button-text light-footer-next" @click="nextClick">
        下一步
      </div>
    </div>
  </div>
</template>

<script scoped>
import store from 'Store/store';
import inputField from 'Components/inputField/inputField.vue';
import validation from 'Core/validation.js';
import scrollToElement from 'scroll-to-element';

export default {
  name: 'ServiceLightStep2',
  components: {
    inputField,
  },
  data() {
    return {
      info: {
        applyName: '',
        applyPhone: '',
      },
      errorText: {
        applyName: '',
        applyPhone: '',
      },
    };
  },
  beforeMount() {
    this.info = this.applyInfo;
  },
  mounted() {},
  methods: {
    previousClick() {
      this.$emit('previousStep');
    },
    nextClick() {
      this.validateFormat() && this.validateLogic() && this.goNextStep();
    },
    goNextStep() {
      store.dispatch('main/modifyLightApplyInfo', this.info);
      this.$emit('nextStep');
    },
    onInput(inputValue) {
      Object.assign(this.info, inputValue);
    },
    // 參數格式是否正確
    validateFormat() {
      Object.keys(this.info).forEach((element) => {
        if (validation[element] === undefined) {
          this.errorText[element] = '';
        } else if (this.info[element] === '') {
          this.errorText[element] = '必填';
        } else if (!validation[element].regex.test(this.info[element])) {
          this.errorText[element] = validation[element].msg;
        } else {
          this.errorText[element] = '';
        }
      });
      return this.checkError();
    },
    // 商業邏輯是否正確
    validateLogic() {
      return this.checkError();
    },
    // 確認有無error
    checkError() {
      let validateResult = true;
      let scrollFirstElement = true;
      Object.keys(this.errorText).forEach((element) => {
        if (this.errorText[element] !== '') {
          if (scrollFirstElement) {
            scrollToElement(`#${element}`, {
              offset: window.innerWidth < 768 ? -100 : -190,
              ease: 'out-circ',
              duration: 500,
            });
            scrollFirstElement = false;
          }
          validateResult = false;
        }
      });
      return validateResult;
    },
  },
  computed: {
    displayInfo() {
      return this.applyInfo;
    },
    applyInfo() {
      return store.state.main.lightApplyInfo;
    },
  },
};
</script>

<style>
.light-apply {
  margin: 0px 5px 0px 5px;
  display: flow-root;
}

.light-name {
  margin-top: 50px;
}

.light-phone {
  margin-top: 10px;
}

.light-footer-steps {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.light-footer-previous {
  margin-right: 15px;
}

.light-footer-next {
  margin-left: 15px;
}

@media (min-width: 768px) {
  .light-name,
  .light-phone {
    width: calc(50% - 20px);
  }

  .light-name {
    float: left;
  }

  .light-phone {
    float: right;
  }

  .light-phone {
    margin-top: 50px;
  }

  .light-footer-steps {
    margin-top: 150px;
  }
}
</style>
